import $ from 'jquery';

class HamburgerMenu {
    constructor() {}

    clickHandler() {
        if (this.opened) {
            this.closeMenu();
            return;
        }
        this.openMenu();
        return;
    }

    closeMenu() {
        this.opened = false;
        this.$window.trigger('fc:hamburger:close');
        this.$menu.removeClass('open');
        this.$overlay.removeClass('open');
        this.$html.css({
            overflow: 'auto'
        });
    }

    openMenu() {
        this.opened = true;
        this.$window.trigger('fc:hamburger:open');
        this.$html.css({
            overflow: 'hidden'
        });
        this.$overlay.addClass('open');
        this.$menu.addClass('open');
    }

    on() {
        this.scopedClickListener = this.clickHandler.bind(this);
        this.$clickArea = $('.hamburger-click-area');
        this.$overlay = $('.nav-bar-wrapper .overlay');
        this.$menu = $('.hamburger-menu-body');
        this.$html = $('body');
        this.$window = $(window);
        this.opened = false;
        this.$overlay.on('click', this.scopedClickListener);
        this.$clickArea.on('click', this.scopedClickListener);
        return this;
    }

    off() {
        this.$overlay.off('click', this.scopedClickListener);
        this.$clickArea.off('click', this.scopedClickListener);
        return this;
    }
}

export default new HamburgerMenu();
